module.exports = __webpack_public_path__ + "static/media/image1.5f891580.JPG";